<template>

    <form autocomplete="off" v-on:submit.prevent="submit">

        <trax-ui-input type="text" :placeholder="lang.polaris.form.name" v-model="form.name" required="1">
        </trax-ui-input>

        <div class="fileinput fileinput-new mt-4" data-provides="fileinput">
            <span class="btn btn-default btn-file" style="cursor:pointer;">
                <span class="fileinput-new">{{ lang.polaris.form.select_file }}</span>
                <span class="fileinput-exists">{{ lang.polaris.form.select_file }}</span>
                <input type="file" :id="id+'-file-input'" name="..." accept="application/pdf, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation" @change="fileChanged">
            </span>
            <span class="fileinput-filename" :id="id+'-file-name'"></span>
            <!--
            <a href="#" class="close fileinput-exists" data-dismiss="fileinput" style="float: none">&times;</a>
            -->
        </div>
        
        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" data-dismiss="modal"> {{ lang.polaris.form.cancel }} </button>
            <button type="submit" class="btn btn-primary btn-round"> {{ lang.polaris.form.save }} </button>
        </div>
        
    </form>
    
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null,
            endpoint: null,
        },
    
        data: function() {
            return {
                lang: lang,
                form: {},
            }
        },

        created: function() {
            this.bus.$on(this.id+'-edit-open', this.open);
        },
        
        methods: {

            open(data) {
                this.form = data ? data : {}
                document.getElementById(this.id+'-file-input').value = '';
                document.getElementById(this.id+'-file-name').innerHTML = '';
            },

            fileChanged(e) {
                this.form.file = e.target.files[0];
            },

            submit() {
                var that = this;
                var formData = new FormData();
                if (this.form.id) {
                    formData.append('id', this.form.id);
                }
                formData.append('name', this.form.name);
                if (this.form.file) {
                    formData.append('file', this.form.file);
                }
                axios.post(
                        this.endpoint, 
                        formData,
                        // {headers: {'Content-Type': 'multipart/form-data'}}
                    )
                    .then(function (response) {
                        that.bus.$emit(that.id+'-edit-close');
                        that.bus.$emit(that.id+'-edit-created');
                    })
                    .catch(function (error) {
                        if (typeof error.response.data == 'string') {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        } else if (error.response.data.message) {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data.message);
                        }
                    });
            }

        }

    }
</script>
